import React from "react";
import { ExclamationCircleIcon } from "@heroicons/react/20/solid";
import { MagnifyingGlassIcon } from "@heroicons/react/20/solid";

// TODO: Temporarily copy and paste this component.
//       Please modify the actual component on the @biteship/atom.
export default function Input(props) {
  const addOns = props.addOns || [];
  let inputClassName, leadingComponent, trailingComponent;
  if (props.alert) {
    inputClassName = `block w-full px-3 py-2 pr-10 border border-danger-700 focus:outline-none focus:ring-danger-700 focus:border-danger-700 sm:text-sm rounded-md`;
  } else if (props.alertBorder) {
    inputClassName = `block w-full px-3 py-2 pr-10 border border-danger-700 focus:outline-none focus:ring-danger-700 focus:border-danger-700 sm:text-sm rounded-md`;
  } else {
    inputClassName = `appearance-none block w-full px-3 py-2 border border-gray-700 rounded-md shadow-sm placeholder-gray-700 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm`;
  }

  if (addOns.includes("leading")) {
    inputClassName = `pl-10 ${props.leadingClassName} appearance-none block w-full py-2 border border-gray-700 rounded-md shadow-sm placeholder-gray-700 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm`;
    leadingComponent = (
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <span className="text-gray-900 sm:text-sm">{props.leadingText || "IDR"}</span>
      </div>
    );
  } else if (addOns.includes("trailing")) {
    inputClassName = ` pl-3 pr-12 ${props.trailingClassName} appearance-none block w-full py-2 border border-gray-700 rounded-md shadow-sm placeholder-gray-700 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm`;
    trailingComponent = (
      <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
        <span className="text-gray-900 sm:text-sm" id="price-currency">
          {props.trailingText || "g"}
        </span>
      </div>
    );
  } else if (addOns.includes("icon")) {
    inputClassName = `focus:ring-primary focus:border-primary block w-full py-2 pl-10 sm:text-sm border border-gray-700  rounded-md`;
    let icon;
    switch (props.iconName) {
      case "search":
        icon = <MagnifyingGlassIcon className="h-5 w-5 text-gray-700" aria-hidden="true" />;
        break;
      default:
        break;
    }
    leadingComponent = (
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        {icon}
      </div>
    );
  }
  return (
    <div className={props.className}>
      {props.labelHidden ? null : (
        <label htmlFor="email" className="block text-sm font-medium text-gray-900">
          {props.label}
        </label>
      )}

      <div className={`${props.labelHidden ? "" : "mt-1"} relative rounded-md shadow-sm"`}>
        {leadingComponent}
        <input
          type={props.type || "text"}
          name={props.name}
          id={props.id}
          className={`${props.inputClassName} ${inputClassName}`}
          placeholder={props.placeholder}
          onChange={props.onChange}
          onClick={props.onClick}
          onWheel={props.onWheel}
          onKeyDown={props.onKeyDown}
          value={props.value}
          defaultValue={props.defaultValue}
          aria-invalid="true"
          aria-describedby="email-error"
          min={0}
        />
        {trailingComponent}
        <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
          {props.alert && !props.hideAlertIcon ? (
            <ExclamationCircleIcon className="h-5 w-5 text-danger-700" aria-hidden="true" />
          ) : null}
        </div>
      </div>
      {props.alert ? (
        <p className="mt-2 text-sm text-danger-700" id="email-error">
          {props.alert}
        </p>
      ) : null}
    </div>
  );
}

